const getInvalidCharacters = (value: string, regEx: RegExp) => {
  if(typeof value !== "string") return '';

  return value.replace(regEx, '').split('');
}

export {
  getInvalidCharacters
}
